module.exports = __webpack_public_path__ + "img/77.9c3c737b.png";